import { transformConstants } from 'helpers/transformConstants';

const apiHealthEventConstants = transformConstants([
  'MOKAPOS_INGREDIENT_LIBRARY_CREATE_SFI_FAILED',
]);

export { apiHealthEventConstants };
